import type { LoanPlannerSnapshot } from '../core/storage/loanPlannerStorage';
import { apiRequest } from './apiClient';

export type LoanPlannerResponse = {
  planner: LoanPlannerSnapshot | null;
  ignored?: boolean;
  /** True when this is the household's only loan, owned by a partner. */
  shared?: boolean;
};

export async function fetchLoanPlannerRemote(
  loanId: string,
): Promise<LoanPlannerResponse> {
  const params = new URLSearchParams({ loanId });
  return apiRequest<LoanPlannerResponse>(`/loans/planner?${params.toString()}`);
}

export async function pushLoanPlannerRemote(
  snapshot: LoanPlannerSnapshot,
): Promise<LoanPlannerSnapshot | null> {
  const data = await apiRequest<LoanPlannerResponse>('/loans/planner', {
    method: 'PUT',
    body: JSON.stringify(snapshot),
  });
  return data.planner ?? null;
}
